export enum PassingOrder {
	None,
	Left,
	Right,
	Repeat,
}
